/**
 * <pdp-tab-group>
 * PetLabCo-style tabbed information panel.
 * Handles click + keyboard navigation per WAI-ARIA tabs pattern.
 *   - Left/Right arrows move focus between tabs
 *   - Home/End jump to first/last tab
 *   - Tab selection activates the tab and reveals its panel
 */
if (!customElements.get('pdp-tab-group')) {
  customElements.define(
    'pdp-tab-group',
    class PdpTabGroup extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      }

      connectedCallback() {
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', (e) => this.onKeyDown(e, index));
        });
      }

      activate(index) {
        const targetIndex = (index + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((tab, i) => {
          const isActive = i === targetIndex;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
          tab.classList.toggle('pdp-tabs__tab--active', isActive);
        });
        this.panels.forEach((panel, i) => {
          const isActive = i === targetIndex;
          panel.classList.toggle('pdp-tabs__panel--active', isActive);
          if (isActive) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      }

      focusTab(index) {
        const targetIndex = (index + this.tabs.length) % this.tabs.length;
        this.activate(targetIndex);
        this.tabs[targetIndex].focus();
      }

      onKeyDown(event, currentIndex) {
        switch (event.key) {
          case 'ArrowRight':
            event.preventDefault();
            this.focusTab(currentIndex + 1);
            break;
          case 'ArrowLeft':
            event.preventDefault();
            this.focusTab(currentIndex - 1);
            break;
          case 'Home':
            event.preventDefault();
            this.focusTab(0);
            break;
          case 'End':
            event.preventDefault();
            this.focusTab(this.tabs.length - 1);
            break;
          default:
            break;
        }
      }
    }
  );
}
